<div class="int-card signUp">
    <mat-card class="sign-up-card">
        <h1 class="title-signup">{{ 'account.signUp.title' | translate }}</h1>
        <mat-horizontal-stepper [linear]="true" #stepper>
            <mat-step [stepControl]="terms" [editable]="true">
                <form [formGroup]="terms">
                    <ng-template matStepLabel>{{'account.signUp.terms' | translate }}</ng-template>
                    <div class="terms-page">
                        <div *ngIf="termsOfUseURL !== ''">
                            <iframe id="termsOfUseIFrame" src="" class="termsContainer"></iframe>
                        </div>
                    </div>
                    <mat-radio-group formControlName="accept" >
                        <mat-radio-button class="small-label" [value]="true" #button (click)="acceptTerms(button)">{{ 'account.signUp.accept' | translate }}</mat-radio-button>
                    </mat-radio-group>

                    <div class="buttons no-margin">
                        <button mat-flat-button class="btn outlined" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
                        <button mat-flat-button class="btn default" matStepperNext [disabled]="terms.invalid || loading">{{ 'button.next' | translate }}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="personalData" [editable]="true">
                <form [formGroup]="personalData">
                    <ng-template matStepLabel>{{'account.signUp.personalData' | translate }}</ng-template>
                    <p class="stepper-title">{{'account.signUp.personalData' | translate }}</p>
                    <div class="wrapper-hint">
                        <input class="input" formControlName="name"
                            [placeholder]="'account.signUp.fullName' | translate" required>
                        <div class="not-match absolute"
                            *ngIf="(personalData?.controls?.name?.invalid && personalData?.controls?.name?.value)">
                            {{ 'account.signUp.hint.name' | translate }}
                        </div>
                    </div>

                    <div class="radio-group-signup">
                        <mat-checkbox formControlName="isBrazilian" [(ngModel)]="isBrazilianCheck" color="primary"
                            (change)="clearInputCpg()">
                            {{ 'account.signUp.brazilian' | translate }}
                        </mat-checkbox>

                        <mat-radio-group formControlName="person" selected>
                            <mat-radio-button *ngIf="isBrazilianCheck" class="small-label" (change)="clearInputCpg()"
                                [value]="true">{{ 'account.signUp.naturalPerson' | translate }}</mat-radio-button>
                            <mat-radio-button *ngIf="isBrazilianCheck" class="small-label" (change)="clearInputCpg()"
                                [value]="false">{{ 'account.signUp.legalEntity' | translate }}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="wrapper-hint">
                        <input matInput class="input" formControlName="cpg" type="text" maxlength="50"
                            [mask]="isBrazilianCheck ? (personalData?.value?.person ? '000.000.000-00' : '00.000.000/0000-00') : ''"
                            [showMaskTyped]="true" [placeholder]="'account.signUp.internationalDocument' | translate" (keypress)="blockSpecialCharacters($event)"
                            (input)="documentAlreadyRegistered = false" required>
                        <div class="not-match absolute"
                            *ngIf="(personalData?.controls?.cpg?.invalid && personalData?.controls?.cpg?.value)">
                            {{ 'account.signUp.hint.identification' | translate }}
                        </div>
                        <div class="not-match absolute" *ngIf="documentAlreadyRegistered && !personalData?.controls?.cpg?.invalid">
                            {{ 'account.validation.exists' | translate }}
                        </div>
                    </div>
                    <mat-progress-spinner *ngIf="loadingData" class="spinner" [mode]="'indeterminate'">
                    </mat-progress-spinner>
                    <div class="buttons no-margin">
                        <button mat-flat-button class="btn outlined" matStepperPrevious>{{ 'button.back' | translate
                            }}</button>
                        <button mat-flat-button class="btn default" (click)="verifyDocument()"
                            [disabled]="toDisabledForwardStepperButton()">{{ 'button.next' | translate
                            }}</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="userData" [editable]="true">
                <ng-template matStepLabel>{{'account.signUp.userData' | translate }}</ng-template>
                <form [formGroup]="userData">
                    <p class="stepper-title">{{'account.signUp.userData' | translate }}</p>
                    <div class="wrapper-hint">
                        <input class="input" formControlName="email" type="text"
                            [placeholder]="'account.login.user' | translate" required>
                        <div class="not-match absolute"
                            *ngIf="(userData?.controls?.email?.invalid && userData?.controls?.email?.touched)">
                            {{ 'account.signUp.hint.email' | translate }}
                        </div>
                    </div>

                    <div class="wrapper-hint">
                        <div class="input-icon reset">
                            <input class="input" formControlName="password"
                                [type]="showNewPassword ? 'text' : 'password'"
                                [placeholder]="'account.signUp.password' | translate" appBlockPaste maxlength="20"
                                required (input)="validatePassword()" (drop)="onDrop($event)">
                            <mat-icon (click)="showNewPassword = !showNewPassword">{{ showNewPassword ? 'visibility_off'
                                : 'visibility' }}</mat-icon>
                        </div>
                        <div class="not-match absolute"
                            *ngIf="(userData?.controls?.password?.invalid && userData?.controls?.password?.touched)">
                            {{ 'account.signUp.hint.password' | translate }}
                        </div>
                    </div>

                    <div class="prerequisites-instructions" [ngClass]="{'margin-top': showPrerequisites}">
                        <mat-icon class="help" [ngClass]="{ 'up' : (!showPrerequisites && userData?.controls?.password?.invalid
                            && userData?.controls?.password?.touched)}" *ngIf="!showPrerequisites"
                            (click)="showPrerequisites = !showPrerequisites; validatePassword()">info</mat-icon>
                        <span class="title" *ngIf="showPrerequisites">{{ 'account.signUp.prerequisites.title' |
                            translate }}</span>
                        <div class="password-help" *ngIf="showPrerequisites">
                            <mat-icon class="hide-help" (click)="showPrerequisites = !showPrerequisites;">
                                keyboard_arrow_up</mat-icon>
                            <div class="left">
                                <div class="password-hint">
                                    <mat-icon matPrefix class="{{ hasMinChars ? 'check' : 'notCheck' }}">done</mat-icon>
                                    <span>{{ 'account.signUp.prerequisites.long' | translate }}</span>
                                </div>
                                <div class="password-hint">
                                    <mat-icon matPrefix class="{{ hasLowerCase ? 'check' : 'notCheck' }}">done
                                    </mat-icon>
                                    <span>{{ 'account.signUp.prerequisites.lower' | translate }}</span>
                                </div>
                                <div class="password-hint">
                                    <mat-icon matPrefix class="{{ hasUpperCase ? 'check' : 'notCheck' }}">done
                                    </mat-icon>
                                    <span>{{ 'account.signUp.prerequisites.upper' | translate }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <div class="password-hint">
                                    <mat-icon matPrefix class="{{ hasNumber ? 'check' : 'notCheck' }}">done</mat-icon>
                                    <span>{{ 'account.signUp.prerequisites.number' | translate }}</span>
                                </div>
                                <div class="password-hint">
                                    <mat-icon matPrefix class="{{ hasSpecialChar ? 'check' : 'notCheck' }}">done
                                    </mat-icon>
                                    <span>{{ 'account.signUp.prerequisites.special' | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="input-icon reset">
                        <input class="input" formControlName="confirmPassword"
                            [type]="showRepeatedPassword ? 'text' : 'password'" (input)="matchPass()"
                            (drop)="onDrop($event)" [placeholder]="'account.signUp.repeatPass' | translate"
                            appBlockPaste maxlength="20" required>
                        <mat-icon (click)="showRepeatedPassword = !showRepeatedPassword">{{ showRepeatedPassword ?
                            'visibility_off' : 'visibility' }}</mat-icon>
                    </div>
                    <div class="not-match absolute" *ngIf="!match || userData?.controls?.confirmPassword?.invalid
                        && userData?.controls?.confirmPassword?.touched && userData?.value?.confirmPassword">
                        {{ 'account.reset.hint.notMatch' | translate }}
                    </div>
                </form>
                <div class="buttons  no-margin">
                    <button mat-flat-button class="btn outlined" matStepperPrevious>{{ 'button.back' | translate
                        }}</button>
                    <button mat-flat-button class="btn default create-account" (click)="signUp()"
                        [disabled]="userData?.invalid || !accept || loading || !match">{{ 'account.signUp.createAccount'
                        | translate }}</button>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </mat-card>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
